import React, {
    useEffect,
    useState,
} from 'react';
import styled from 'styled-components';

import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import { useMedia } from 'bdvp-common/src/hooks';
import Reels from 'bdvp-reel/src/containers/Reels';

import Menu from '../../containers/Menu';
import SearchButton from '../SearchButton';
import SearchInput from '../SearchInput';
import Branding from '../Branding';
import BaseSubnav, {
    BaseMenuReels,
    BaseMenuWrapper,
    BaseSearchButtonWrapper,
    BaseBrandingWrapper
} from './BaseSubnav';

const Navbar = styled(BaseSubnav)`
    ${media.mdmin`
        padding: 0 4px 0 9px;
        grid-template-areas: 'branding search menureels';
        grid-template-columns: 1fr 2fr 1fr;
    `}
    ${media.lgmin`
        padding: 0 22px;
        grid-template-columns: 1fr 1fr 1fr;
    `}
`;

const FreeTextNavbar = styled(BaseSubnav)`
    display: flex;
    align-items: center;
    padding: 0 4px 0 14px;
`;

const BrandingWrapper = styled(BaseBrandingWrapper)`
    ${media.mdmin`
        justify-self: self-start;
    `}
`;

const SearchButtonWrapper = styled(BaseSearchButtonWrapper)`
    ${media.mdmin`
        justify-self: center;
        width: 80%;
        margin-left: 40px;
    `}


    ${media.lgmin`
        width: 100%;
        margin-left: 0px;
    `}
`;

const FreeTextSearchSubnav = () => {

    const isMobile = useMedia([`(min-width: ${BREAKPOINTS.md})`], [false], true);

    const [
        showFreeTextInput,
        setShowFreeTextInput,
    ] = useState(false);

    const [
        hasMounted,
        setHasMounted,
    ] = useState(false);

    useEffect(() => {

        setHasMounted(true);

    }, []);

    return (
        isMobile && showFreeTextInput
            ? (
                <FreeTextNavbar>
                    <SearchInput setShowFreeTextInput={setShowFreeTextInput} />
                </FreeTextNavbar>
            )
            : (
                <Navbar>
                    <BrandingWrapper>
                        <Branding />
                    </BrandingWrapper>
                    <SearchButtonWrapper>
                        {hasMounted && (
                            isMobile
                                ? <SearchButton onClick={() => setShowFreeTextInput(true)} />
                                : <SearchInput />
                        )}
                    </SearchButtonWrapper>
                    <BaseMenuReels>
                        <BaseMenuWrapper>
                            <Menu />
                        </BaseMenuWrapper>
                        <Reels />
                    </BaseMenuReels>
                </Navbar>
            )
    );

};

export default FreeTextSearchSubnav;
